import { extendTheme } from "@chakra-ui/react";
import { ButtonConfig } from "@/components/atoms/button/ButtonStyles";
import { CardConfig } from "@/components/molecules/card/CardStyles";
import { CheckboxConfig } from "@/components/atoms/checkbox/CheckboxStyles";
import { ChipConfig } from "@/components/atoms/chip/ChipStyles";
import { typography } from "./typography";

export const theme = extendTheme({
  colors: {
    brand: {
      aubergine: "#900054",
      dark: "#400D2B",
      blue: "#2257FF",
      green: "#4AA84A",
      white: "#fff",
      grey: "#F7F2F5",
      cyan: "#0095FF",
      orange: "#E57700",
    },
    aubergine: {
      50: "#FBF4F8",
      100: "#F7E9F1",
      200: "#EED3E2",
      300: "#E0B3CD",
      400: "#CE87B1",
      500: "#C15795",
      600: "#B12F7B",
      700: "#9F1465",
      800: "#900054",
      900: "#610A3D",
      950: "#400D2B",
      rgb: "102, 51, 153",
    },
    gray: {
      50: '#F7FAFC',
      100: '#EDF2F7',
      200: '#E2E8F0',
      300: '#CBD5E0',
      400: '#A0AEC0',
      500: '#718096',
      600: '#4A5568',
      700: '#2D3748',
      800: '#1A202C',
      900: '#171923',
    },
    green: {
      500: "#82E068",
    },
  },
  shadows: {
    brand: {
      dark: "0 3px 4px rgba(64, 13, 43, 0.15)",
    },
  },
  textStyles: typography,
  fonts: {
    heading: `'Cooper', serif`,
    body: `'Lausanne', sans-serif`,
  },
  breakpoints: {
    "3xl": "120rem",
  },
  zIndices: {
    modal: 2000,
  },
  sizes: {
    contentmodule: "36.625rem",
  },
  components: {
    ButtonConfig,
    CardConfig,
    Checkbox: CheckboxConfig,
    Chip: ChipConfig,
  },
});